import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { getAuth } from '../../hooks/useAuth'; // ✅ Use getAuth, não useAuth

interface PrivateRouteProps extends RouteProps {
  allowedProfiles: number[];
  component: React.ComponentType<any>;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  allowedProfiles,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        // ✅ Chama getAuth() dentro do render, não como hook
        const { isLoggedIn, profileId } = getAuth();

        // Se não está logado, redireciona para login
        if (!isLoggedIn) {
          return <Redirect to="/login" />;
        }

        // Se o perfil não está na lista permitida, redireciona para login
        if (
          allowedProfiles.length > 0 &&
          !allowedProfiles.includes(Number(profileId))
        ) {
          return <Redirect to="/login" />;
        }

        // Renderiza o componente
        return <Component {...props} />;
      }}
    />
  );
};
